import React from 'react'
import marked from 'marked'
import gsap from 'gsap'
import { TransitionGroup, Transition } from 'react-transition-group'

import CustomHelmet from '../components/CustomHelmet'
import Hero from '../components/ProgramOverview/Hero'
import Apply from '../components/Apply'
import Helmet from 'react-helmet'
import Row from '../components/Shared/Row'
import BannerImage from '../components/Destination/BannerImage'
import Column from '../components/Shared/Column'
import scrollTo from '../components/scroller'
import ImageCycle from '../components/ImageCycle'

class careers extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			sliderActive: 0
		}

	}
	componentDidMount() {
		const {
			data: { page, posts }
		} = this.props
		// const { sliderActive } = this.state
		this.sliderInterval = setInterval(() => {
			const { sliderActive } = this.state
			var newActiveIndex =
				sliderActive >= page.slider.length - 1 ? 0 : sliderActive + 1
			this.setState({ sliderActive: newActiveIndex })
		}, 4500)


	}
	enterSliderImage(node) {}
	exitSliderImage(node) {
		TweenMax.set(node, {
			css: { position: 'absolute', zIndex: 10, top: 0, left: 0 }
		})
		TweenMax.to(node, 1.4, { autoAlpha: 0 })
	}
	componentWillUnmount() {
		clearInterval(this.sliderInterval)
	}

	getJobCategories() {
		const {
			data: { posts }
		} = this.props

		let jobCategories = []

		posts.edges.forEach( job => {
			if (job.node.jobCategory != null && jobCategories.indexOf(job.node.jobCategory) === -1) {
				jobCategories.push(job.node.jobCategory)
			}

		})
		return jobCategories
	}


	render() {
		const {
			data: { page, posts }
		} = this.props
		console.log('PAGE INFO ==> ',posts)

		let jobCategories = this.getJobCategories()
		return (
			<div className="careers page-redesign">
				<CustomHelmet data={page.seoData} fallBack={page} />
				<Hero title={page.title} />
				<Row className="contentWrapper capper">
					<Column width="12">
						<h2 className="h2 intro">{page.secondaryHeadline}</h2>
						{page.introText && (
							<div
								className="expanded"
								dangerouslySetInnerHTML={{
									__html: marked(page.introText.introText)
								}}
							/>
						)}
					</Column>
				</Row>

				<Row className="contentWrapper capper no-top-padding">
					<Column width="6" offsetL="3" tablet="12" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">Central Office</h2>
								{ jobCategories.indexOf('Central Office') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'Central Office' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" taget="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('Oakland') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column>
					{ /* <Column width="6" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">Brazil</h2>
								{ jobCategories.indexOf('Brazil') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'Brazil' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" target="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('Brazil') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column>
					<Column width="6" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">Ecuador</h2>
								{ jobCategories.indexOf('Ecuador') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'Ecuador' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" target="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('Ecuador') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column>
					<Column width="6" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">India</h2>
								{ jobCategories.indexOf('India') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'India' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" target="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('India') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column>
					<Column width="6" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">Senegal</h2>
								{ jobCategories.indexOf('Senegal') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'Senegal' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" target="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('Senegal') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column> */ }
					<Column width="6" offsetL="3" tablet="12" mobile="12">
						{posts.edges &&
							<div className="job-openings">
								<h2 className="h2 intro">Alumni Opportunities</h2>
								{ jobCategories.indexOf('Alumni Opportunities') !== -1 &&
									<span>
										{ posts.edges.map( post => {
											if (post.node.jobCategory === 'Alumni Opportunities' && post.node.showOnCareersPage) {
													return (
														<div
															key={post.node.id}
															className="job"
															key={post.node.id}
														>
															<h4>{post.node.jobTitle}</h4>
															<p>{post.node.excerpt}</p>
															<a href={post.node.slug} className="hoverlink" target="_blank">
																See the position
															</a>
														</div>
													)
											}
										})}
									</span>
								}
								{ jobCategories.indexOf('Alumni Opportunities') === -1 &&
									<p>There are currently no job opportunities posted for this team. Please check back soon!</p>
								}
							</div>
						}
					</Column>

				</Row>
				<Row className="contentWrapper capper no-top-padding">
					<Column width="12">
						{page.sliderSectionTitle && (
							<h2 className="h2">{page.sliderSectionTitle}</h2>
						)}
					</Column>
					<Column width="6" tablet="12" className="career-slide">
						<TransitionGroup>
							<Transition
								key={this.state.sliderActive}
								timeout={1500}
								onEnter={node => this.enterSliderImage(node)}
								onExit={node => this.exitSliderImage(node)}
							>
								<ImageCycle image={page.slider[this.state.sliderActive]} />
							</Transition>
						</TransitionGroup>
					</Column>
					<Column width="6" tablet="12">
						{page.sliderIntro && (
							<div>
								<span
									dangerouslySetInnerHTML={{
										__html: marked(page.sliderIntro.sliderIntro)
									}}
								/>
								<br />
								<br />
								<a href={page.link.link} className="hoverlink">
									{page.link.text}
								</a>
							</div>
						)}
					</Column>
				</Row>
				<Row className="contentWrapper bg-grey">
					<Row className="no-padding contentWrapper capper">
						<Column width="12">
							<h2 className="h2">{page.perksTitle}</h2>
							<p
								className="expanded"
								dangerouslySetInnerHTML={{ __html: page.perksIntro.perksIntro }}
							/>
							<Row className="no-side-padding no-bottom-padding">
								{page.icons.map((icon, index) => (
									<Column
										key={index}
										width="4"
										tablet="6"
										mobile="12"
										className="icon-wrapper"
									>
										<div
											className="icon"
											style={{
												background: `url(${
													icon.icon.file.url
												}) left center no-repeat`,
												backgroundSize: 'contain'
											}}
										/>
										<h3 className="title">{icon.title}</h3>
										<p className="details">{icon.excerpt.excerpt}</p>
									</Column>
								))}
							</Row>
						</Column>
					</Row>
				</Row>
				<section className="bg-dark-grey">
					<div className="block standard-spacing block-download">
						<div>
							<img src="https://images.ctfassets.net/j91b9gwu8s3q/fMmwEP0R4EYEBDAPYbGPb/8bc162a09d5fe53bfb47807a516bdbcf/DEIA_Report_preview.png" alt="booklet mockup" />
						</div>
						<div>
							<h3 className="boldItal color-white">DOWNLOAD OUR DEIA PROGRESS REPORT</h3>
							<p className="color-white">We are continuously striving to deepen our commitment to diversity, equity, inclusion, and anti-racism. We’re sharing this report openly in an effort to lead out loud and be transparent about what we’re learning, what we’re doing well, and what we can improve.</p>
							<a href="https://downloads.ctfassets.net/j91b9gwu8s3q/3TFzDCU13hSUYmbn02RG36/459fcd6aa98e94b3a5dc2a6bdc5e7c33/Global_Citizen_Year_-_DEIA_Progress_Report.pdf" target="_blank" className="hoverlink white">Download Now</a>
						</div>
					</div>
				</section>
				<div className="section">
					<div className="banner-wrap">
						<BannerImage image={page.bannerImage} />
					</div>
				</div>
			</div>
		)
	}
}

export default careers

export const query = graphql`
	query careersQuery {
		page: contentfulCareersPage {
			id
			title
			secondaryHeadline
			introText {
				id
				introText
			}
			bannerImage {
				id
				sizes(quality: 100, maxWidth: 1800) {
					...GatsbyContentfulSizes_withWebp
				}
				file {
					url
					fileName
					contentType
				}
			}
			positionsTitle
			positionsIntro {
				id
				positionsIntro
			}
			sliderSectionTitle
			sliderIntro {
				id
				sliderIntro
			}
			slider {
				id
				file {
					url
					fileName
					contentType
				}
			}
			link {
				id
				text
				link
			}
			perksTitle
			perksIntro {
				id
				perksIntro
			}
			icons {
				id
				title
				excerpt {
					id
					excerpt
				}
				icon {
					id
					file {
						url
						fileName
						contentType
					}
				}
			}
			seoData {
				id
				pageTitle
				pageDescription {
					id
					pageDescription
				}
				keywords
				openGraphTitle
				openGraphDescription {
					id
					openGraphDescription
				}
				openGraphImage {
					id
					file {
						url
						fileName
						contentType
					}
				}
			}
		}
		posts: allContentfulJobPostings (sort:{fields: [date], order: DESC}) {
			edges {
				node {
					id
					slug
					jobTitle
					excerpt
					showOnCareersPage
					jobCategory
                    date
				}
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/careers.js